<div class="modal-container" *ngIf="onboardingForm">
  <form [formGroup]="onboardingForm">
    <div class="modal-header">
      <span class="title">Welcome to TechInsights</span>
      <span class="subtitle">Complete this form to continue</span>
    </div>
    <div class="modal-body">
      <div class="input-container">
        <app-input [props]="firstNameProps" formControlName="firstName"
                   (blurInput)="onBlurControls('firstName', false)"></app-input>
        <app-input [props]="lastNameProps" formControlName="lastName"
                   (blurInput)="onBlurControls('lastName', false)"></app-input>
        <app-input [props]="companyProps" formControlName="company"
                   (blurInput)="onBlurControls('company', false)"></app-input>
        <div class="mb-2">
          <it-select
            *ngIf="departments"
            [placeholder]="departmentsProps.placeholder"
            [label]="departmentsProps.label"
            [error]="departmentsProps.error"
            [options]="departments"
            [initialOption]="initialSelectionOption"
            [editable]="true"
            [upward]="false"
            (changeOption)="onChangeDepartmentFunction($event)"
            (blurInput)="onBlurSelects('departments', true)"></it-select>
          <app-input *ngIf="onboardingForm.controls.departments?.value === OTHER"
                     [props]="otherDepartmentProps"
                     formControlName="otherDepartment"
                     (blurInput)="onBlurControls('otherDepartment', false)"
          ></app-input>

        </div>
        <div class="mb-2">
          <it-select
            *ngIf="titleLevels"
            [placeholder]="titleLevelsProps.placeholder"
            [label]="titleLevelsProps.label"
            [error]="titleLevelsProps.error"
            [options]="titleLevels"
            [initialOption]="initialSelectionOption"
            [editable]="true"
            [upward]="false"
            (changeOption)="onChangeTitleLevelFunction($event)"
            (blurInput)="onBlurSelects('titleLevels', true)"></it-select>
        </div>
        <div class="mb-2">
          <it-select
            *ngIf="countries"
            [placeholder]="countriesProps.placeholder"
            [label]="countriesProps.label"
            [error]="countriesProps.error"
            [options]="countries"
            [initialOption]="initialSelectionOption"
            [editable]="true"
            [upward]="true"
            (changeOption)="onChangeOptionCountry($event)"
            (blurInput)="onBlurSelects('countries', true)"
          ></it-select>
          <it-select
            *ngIf="(onboardingForm.controls.countries.value === US_CODE && states)"

            [placeholder]="stateProps.placeholder"
            [label]="stateProps.label"
            [error]="stateProps.error"
            [options]="states"
            [initialOption]="initialSelectionOption"
            [editable]="true"
            [upward]="true"
            (changeOption)="onChangeOptionState($event)"
            (blurInput)="onBlurSelects('state', true)"
          ></it-select>
        </div>
        <div class="checkbox-style">
          <label class="it-checkbox checkbox-font">
            <input type="checkbox" formControlName="eulaChecked"/>
            <div></div>
            <span>I HAVE READ AND AGREE TO THE
            <a href="https://public.techinsights.com/legal/?d=terms-and-conditions" target="_blank" rel="noopener">END USER LICENSE AGREEMENT</a>
          </span>
          </label>
          <label class="it-checkbox checkbox-font">
            <input type="checkbox" formControlName="ppChecked"/>
            <div></div>
            <span>I HAVE READ AND AGREE TO THE
            <a href="https://public.techinsights.com/legal/?d=privacy-policy" target="_blank" rel="noopener">PRIVACY POLICY</a>
          </span>
          </label>
        </div>
        <section class="button-section">
          <button type="button" class="onboarding-btn-secondary" (click)="onDeclineEULA()">
            Decline and Exit
          </button>
          <button
            type="button"
            class="onboarding-btn-primary"
            (click)="onAcceptEULA()"
            [disabled]="!onboardingForm.valid"
          >
            Agree and Continue
          </button>
        </section>
      </div>
    </div>
    <div class="modal-footer">
    </div>
  </form>
</div>
